import { Injectable } from '@angular/core';
import diarization from '../../assets/mock/diarization.json';
import { AllContentModel, ContentModel, DiarizationModel, IDModel, MyFilesModel, TrainModel, TranslationModel } from '../model/files.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class MyFilesService {
    id: BehaviorSubject<string>;

    entity_service_url = ''
    file_service_url = ''
    translate_transcript_url = ''

    constructor(private http: HttpClient) {
        this.id = new BehaviorSubject("");
        this.entity_service_url = environment.entity_service_url;
        this.file_service_url = environment.file_service_url;
        this.translate_transcript_url = environment.translate_transcript_url;
    }

    getAllContents(email: string): Observable<AllContentModel> {
        // email='undefined'
        return this.http.get<AllContentModel>(this.entity_service_url + "/getUserContents/" + email);
    }

    getContentbyID(id: string): Observable<ContentModel> {
        return this.http.get<ContentModel>(this.entity_service_url + "/getContent/" + id);
    }

    editTranscript(id: any, data: any): Observable<any> {
        const Editeddata = {
            uuid: id,
            field: 'outputs.transcript.result',
            fieldData: data
        };
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.entity_service_url + "/updateContent/", Editeddata, { headers: headers })
    }

    editSpeaker(id: any, data: any): Observable<any> {
        const Editeddata = {
            uuid: id,
            field: 'outputs.speaker_identification',
            fieldData: data
        };
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.entity_service_url + "/updateContent/", Editeddata, { headers: headers })
    }

    archive_files(ids: any): Observable<any> {
        let data: any = {};
        let archive_contents: any[] = [];
        ids.forEach((id: any) => {
            // this.archive_file(file._id, false); 
            let obj = {
                "uuid": id
            }
            archive_contents.push(obj);
        });
        data.archive_contents = archive_contents;

        console.log("deleted files", data)
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.entity_service_url + "/archiveMultiContents", data, { headers: headers })
    }

    uploadFile(formData: any) {
        return this.http.post(this.file_service_url + "/upload/translation", formData, {
            reportProgress: true,
            observe: 'events'
        });
    }

    getTranslationFromModal(data: TranslationModel) {
        return this.http.post(this.translate_transcript_url + "/translation_from_json", data);
    }

    deleteRecordsInDb(){
        return this.http.get(this.entity_service_url+"/emptyCollection");
    }

    getSpeakerInfoFromModal(data: IDModel) {
        return this.http.post(this.translate_transcript_url + "/diarization_and_audioChunkCreation", data);
    }

    getTranscriptFromModal(data: IDModel) {
        return this.http.post(this.translate_transcript_url + "/transcription_from_uploadedAudio_in_Gdrive", data);
    }

    trainNewSpeaker(data: TrainModel) {
        // return this.http.post(environment._shreyonUrl + "train_new_speaker", data);
        return this.http.post(this.translate_transcript_url + "/train_new_speaker", data);
    }

    translateFromJson(data: any) {
        return this.http.post(this.translate_transcript_url + "/translation_from_json", data);
    }

    getDiarization() {
        return of<DiarizationModel>(diarization);
    }

    getIDSubject(): Observable<string> {
        return this.id.asObservable();
    }

    setIDSubject(id: string): void {
        this.id.next(id);
    }

}
